import React, { Component } from 'react';
import arrow from '../../assets/images/icons/arrow-white.svg';
import what_png from '../../assets/images/illustrations/what@3x.png';
import what from '../../assets/images/Autism-webp/What/02_whatIsAutism_R04@3x.webp';
import whatLow from '../../assets/images/illustrations/what@3x-low.png';
import mobileWhat from '../../assets/images/mobile/02_mobile_what_is_autism_r_03@3x.png';
import { lang } from '../../lang';
import { withTranslation } from 'react-i18next';
import windowSize from 'react-window-size';

class HomepageSecond extends Component {
    constructor(props) {
        super(props);
        this.state = { imageStatus: 'loading', width: this.props.windowWidth };
    }

    handleImageLoaded = () => {
        this.setState({ imageStatus: 'loaded' });
    };

    handleImageErrored = () => {
        this.setState({ imageStatus: 'failed to load' });
    };

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    render() {
        const { t, i18n } = this.props;
        return (
            <div
                className={`hp hp-second ${
                    i18n.language === 'en' ? 'text-left' : ''
                }`}
            >
                {this.state.width > 700 ? (
                    <>
                    <picture>
                        <source srcSet={what_png} type='image/png' />
                        <source srcSet={what} type='image/webp' />
                        <img
                            alt='what'
                            src={what}
                            className={`autism-def ${
                                this.state.imageStatus === 'loaded'
                                    ? ''
                                    : 'low-quality aut-low'
                            }`}
                            onLoad={this.handleImageLoaded}
                            onError={this.handleImageErrored}
                        />
                        </picture>
                        {this.state.imageStatus === 'loaded' ? (
                            <></>
                        ) : (
                            <img
                                alt='what'
                                src={whatLow}
                                className={`autism-def`}
                            />
                        )}
                    </>
                ) : (
                    <>
                        <img
                            alt='what'
                            src={mobileWhat}
                            className={`autism-def ${
                                this.state.imageStatus === 'loaded'
                                    ? ''
                                    : 'low-quality aut-low'
                            }`}
                            onLoad={this.handleImageLoaded}
                            onError={this.handleImageErrored}
                        />
                        {this.state.imageStatus === 'loaded' ? (
                            <></>
                        ) : (
                            <img
                                alt='what'
                                src={whatLow}
                                className={`autism-def`}
                            />
                        )}
                    </>
                )}

                {/* <img alt='what' className='autism-def' src={what} /> */}
                <div className='second-statement'>
                    <h2>{t('homepage.autism.title')}</h2>
                    <h5>{t('homepage.autism.desc')}</h5>
                    <a href='/#/autism' className='more-link'>
                        {t('homepage.autism.more')}
                        <img
                            src={arrow}
                            alt='arrow'
                            className={`arrow ${
                                i18n.language === 'en' ? 'flip ml-1' : ''
                            }`}
                        />
                    </a>
                </div>
            </div>
        );
    }
}

export default withTranslation()(windowSize(HomepageSecond));
